import { render, staticRenderFns } from "./IndustryBenchmarking.vue?vue&type=template&id=23e2b28f&scoped=true&"
import script from "./IndustryBenchmarking.vue?vue&type=script&lang=js&"
export * from "./IndustryBenchmarking.vue?vue&type=script&lang=js&"
import style0 from "./IndustryBenchmarking.vue?vue&type=style&index=0&id=23e2b28f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e2b28f",
  null
  
)

export default component.exports